<template lang="pug">
  .units-list.overflow-auto.pt-5.scroll(style="max-height: 75vh")
    lazy-load(
      v-model="loadMore"
      @on-response="({ items }) => courseUnits.push(...items)"
    )
      unit-card(
        v-for="(unit,idx) in courseUnits"
        :key="`${unit.id}${idx}`"
        :unit="unit"
        :to=`{
          name: 'EducationLessonList',
          params: { courseId: course.id, unitId: unit.id },
        }`
      ).mb-10
    v-fade-transition
      v-skeleton-loader.fill-width(
        v-if="loading"
        type="list-item-two-line@5"
      )
</template>

<script>
import UnitCard from '@/modules/Education/Courses/components/UnitCard.vue';

export default {
  components: {
    UnitCard,
  },
  props: {
    course: { type: Object, required: true },
  },
  data: () => ({
    courseUnits: [],
    loading: true,
    loadMore: null,
  }),
  async created() {
    this.loading = true;
    await this.getCourseUnits();
    this.loading = false;
  },
  methods: {
    async getCourseUnits() {
      const params = {
        expand: 'lessons,tasks,user_passed',
      };
      const { items, loadMore } = await this.$api.courses.courseUnitIndex(
        this.course.id,
        params, { hideErrorToasts: true },
      );
      this.loadMore = loadMore;
      this.courseUnits = items;
      this.checkUnreads();
    },
    checkUnreads() {
      this.courseUnits.forEach((i) => {
        i.fetchUnread();
      });
    },
  },
};
</script>
